module.exports = __webpack_public_path__ + "static/img/l5.0623fbe.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/landing_page/l5.jpg
// module id = 638
// module chunks = 0